import { Select, SelectProps } from "antd";

import { ReactComponent as DropdownIcon } from "images/dropDownIcon.svg";
import styles from "./select.module.css";

export const DefaultSelect: React.FC<SelectProps> = (props) => (
  <label className={styles.inputBlock}>
    <Select
      className={`${styles.input} ${props.className}`}
      variant="outlined"
      {...props}
      placeholder=""
      suffixIcon={<DropdownIcon />}
    >
      {props.children}
    </Select>
    {props.placeholder && (
      <span className={`${styles.label} ${props.value !== "" && props.value !== undefined ? styles.labelTop : ""}`}>
        {props.placeholder}
      </span>
    )}
  </label>
);
